import React, { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AddBtn } from "@commonComponents/AddBtn";
import { FormTitle } from "@commonComponents/FormTitle";
import { selectBorderTransportMeanList, selectMotTypeList } from "@EUForms/selectors";
import { defaultTransMode } from "../../util";


const BorderTransportDetail = (props) => {
  const { 
    translate, 
    renderForm, 
    addItem, 
    tableName = "borderTransportMeansList", 
    updateItem: onChange, 
    saveItem: onBlur, 
    onSelect, 
    updateData, 
    saveData
  } = props

  const dataSource = useSelector(selectBorderTransportMeanList);
  let motTypeList = useSelector(selectMotTypeList)
  motTypeList = dataSource?.[0]?.modeOfTransport ? motTypeList?.filter((motType) => {
    return ['1','2','3','4','8'].includes(dataSource?.[0]?.modeOfTransport)
      ? motType.value.startsWith(dataSource?.[0]?.modeOfTransport) 
      : true
  }) : []
  const dispatch = useDispatch()

  const onDropDownChange = useCallback((id, tableName, payload) => {
    if (payload.hasOwnProperty("modeOfTransport") && (!payload.modeOfTransport || !defaultTransMode?.[payload.modeOfTransport])) {
      onSelect(id, tableName, { ...payload, type: '' })
    } else if (payload.hasOwnProperty("modeOfTransport") && defaultTransMode?.[payload.modeOfTransport]) {
      onSelect(id, tableName, { ...payload, type: defaultTransMode?.[payload.modeOfTransport] })
      saveData({ terminal: " " })
      dispatch(updateData({ terminal: "" }))
    } else if (payload.hasOwnProperty("modeOfTransport")) {
      onSelect(id, tableName, payload)
      saveData({ terminal: " " })
      dispatch(updateData({ terminal: "" }))
    } else {
      onSelect(id, tableName, payload)
    }
  }, [onSelect, updateData])

  return (
    <div className="col formContainer">
      <FormTitle className="formTitle" textAlign="start" boxNumber="7/4" title="MOT_BORDER" />
      {dataSource.length > 0 ? renderForm({
        onChange,
        onBlur,
        dataSource: dataSource[0],
        motTypeList,
        onSelect: onDropDownChange,
        tableName,
        translate
      }) : <AddBtn
        style={{ width: "max-content" }}
        onClick={() => addItem(tableName)}
        text={translate("ADD")}
      />}
    </div>
  )
}

export default React.memo(BorderTransportDetail)
